export const initialState = {}


export const getDocuments = (state,delta) => state[delta] && state[delta].documents || null


// WEBPACK FOOTER //
// ./src/interface/store/departments/rxdb/selectors.js